module.exports = __webpack_public_path__ + "img/图层528.ea7b5c50.png";